:host {
    @include typo-ws-paragraph;
}

.headline {
    @include typo-ws-h3;

    margin: 0 0 24px;
}

a {
    color: $color-red;
    text-decoration: none;

    &[href^='tel:'] {
        white-space: nowrap;
    }
}

.intro {
    margin-bottom: 24px;
}

.step {
    margin-top: 16px;
    border-top: 1px solid $color-grey-02-steel;
    padding-top: 12px;
}

.split {
    display: flex;
    column-gap: 10px;
}

::slotted(sew-picture) {
    width: 80px;
    flex-shrink: 0;
}
